
export var IGEmbedHelper = {
  processEmbedPost: function (nextTick) {
    if (window.instgrm && window.instgrm.Embeds) {
      nextTick(() => {
        window.instgrm.Embeds.process()
      })
    } else {
      let oldScripts = window.document.querySelectorAll('script[src="https://www.instagram.com/embed.js"]')
      for (let script of oldScripts) script.remove()
      window.document.body.appendChild(Object.assign(document.createElement('script'), { 'async': '', 'src': 'https://www.instagram.com/embed.js' }))
    }
  }
  // fetchPostInfo: function (postURL) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       let apiURL = `https://graph.facebook.com/v9.0/instagram_oembed?url=${postURL}&access_token=${'？？？'}`
  //       let xhr = new XMLHttpRequest()
  //       xhr.open('GET', apiURL, true)
  //       xhr.onreadystatechange = function () {
  //         console.log(`IGEmbedHelper.fetchEmbedHtml this.readyState=${this.readyState}, this.status=${this.status}`)
  //         if (this.readyState === 4) {
  //           if (this.status === 200) {
  //             let postInfo = JSON.parse(this.responseText)
  //             resolve(postInfo)
  //           } else if (this.status >= 300) {
  //             reject(Error(`${this.status}: ${this.responseText}`))
  //           }
  //         }
  //       }
  //       xhr.send()
  //     } catch (err) {
  //       reject(err)
  //     }
  //   })
  // }
}
